import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DemoDataService } from '../services/demo-data.service';

export const demoBackendInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.demoMode) {
    return next(req);
  }

  const demoBackend = inject(DemoDataService);
  const demoResponse = demoBackend.handle(req);
  return demoResponse ?? next(req);
};
